import { cn } from '@/lib/cn'
import { asset } from '@/lib/assets'
import { BRAND } from '@/brand/brand'
import styles from './Logo.module.css'

export type LogoTone = 'light' | 'dark'

/**
 * The brand mark, served from R2 as supplied. We never redraw it, so gradients
 * and proportions stay exactly as designed for whichever brand is building.
 */
export function PassMark({
  size = 28,
  className,
}: {
  readonly size?: number
  readonly className?: string | undefined
}) {
  return (
    <img
      src={asset(BRAND.mark)}
      alt=""
      width={Math.round(size * BRAND.markRatio)}
      height={size}
      className={cn(styles.mark, className)}
      style={{ height: size, width: 'auto' }}
      draggable={false}
    />
  )
}

/** Mark plus wordmark. The wordmark scales from the mark so the pair stays locked. */
export function Logo({
  size = 28,
  tone = 'light',
  className,
}: {
  readonly size?: number
  readonly tone?: LogoTone
  readonly className?: string | undefined
}) {
  return (
    <span className={cn(styles.lockup, tone === 'dark' ? styles.onDark : styles.onLight, className)}>
      <PassMark size={size} />
      <span className={styles.wordmark} style={{ fontSize: size * 0.82 }}>
        {BRAND.wordmark}
      </span>
    </span>
  )
}
